export default __webpack_public_path__ + "static/media/sitemeup_logo-01.e2739b42.svg";